import { TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedCard } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { toFeatured$ } from '../../serializer/featured';

@Component({
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
    },
    template: require('./task-featured-card.html'),
})
export class TaskFeaturedCard extends ReactiveVue {
    public $taskDataStore: TaskDataStore;
    public serializer = toFeatured$;
}
